import logo from '../../../assets/img/icons/toca-logo-black.png';

export const TocaLogo = () => {
  return (
    <div className="toca-logo flex h-[64px] mt-4">
      <img src={logo} className="max-w-[120px] object-contain" />
    </div>
  );
};
